import React from "react";
import { motion } from "framer-motion";
import { BoxIcon } from "lucide-react";
interface SectionCardProps {
  title: string;
  description?: string;
  icon: BoxIcon;
  /** Optional right-aligned slot, e.g. a badge. */
  aside?: React.ReactNode;
  children: React.ReactNode;
}
export function SectionCard({
  title,
  description,
  icon: Icon,
  aside,
  children
}: SectionCardProps) {
  return <motion.section layout initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -4
  }} transition={{
    duration: 0.22,
    ease: [0.16, 1, 0.3, 1]
  }} className="rounded-lg border border-ink-200 bg-white shadow-card" data-id="element-203" data-mp="linwwhanwwh2">
      <header className="flex items-start gap-3 border-b border-ink-100 px-5 py-3.5" data-id="element-204" data-mp="zhxbjcj7ziix">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-ink-100 text-ink-600" data-id="element-205" data-mp="zfkpan6fim02">
          <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-206" data-mp="2awu6f32351y7" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-207" data-mp="2ayx50bhb03ej">
          <h3 className="text-sm font-semibold leading-5 text-ink-900" data-id="element-208" data-mp="x5bcknrise44">{title}</h3>
          {description && <p className="mt-0.5 text-xs leading-5 text-ink-500" data-id="element-209" data-mp="t36l9vojntkn">{description}</p>}
        </div>
        {aside}
      </header>
      <div className="px-5 py-4" data-id="element-210" data-mp="o2sa44rnc3ie">{children}</div>
    </motion.section>;
}